import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { downloadButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a href={`http://onelink.to/sushimodo`}>
              <CFView hover>
                <CFImage
                  src={downloadButton}
                  w="50%"
                  minWidth="200px"
                  alt="About"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a href={`http://onelink.to/sushimodo`}>
              <CFView hover>
                <CFImage src={downloadButton} maxWidth="200px" alt="About" />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
